import { Mail } from 'lucide-react';
import { CONTACT } from '../data';

export const FloatingCTA = () => (
    <div className="fixed bottom-6 right-6 z-50">
        <a
            href={`mailto:${CONTACT.email}?subject=Loan%20Enquiry%20—%20Prem%20Associates`}
            data-testid="email-float-button"
            aria-label="Email Prem Associates"
            className="block p-3.5 rounded-full bg-emerald-500 text-[#04110c] hover:scale-110 animate-pulse-ring transition-transform duration-300"
        >
            <Mail className="w-5 h-5" />
        </a>
    </div>
);
